<template>
  <w-settings-summary ref="settingsSummary" :menu="menu" @change="onChangeMenu">
    <component slot="activeView" :is="activeView" :title="activeMenu.name"></component>
  </w-settings-summary>
</template>

<script>
import WSettingsSummary from '@/components/template/SettingsSummary';
import WCollectionSettings from './Collect';
import WAlarmSettings from './Alarm';
import WPatternSettings from './Pattern';

export default {
  name: 'WLogSettings',
  components: {
    WSettingsSummary,
    WCollectionSettings,
    WAlarmSettings,
    WPatternSettings,
  },
  data() {
    return {
      activeMenu: {},
      activeView: null,
      menu: [
        {
          id: 'collectionSettings',
          name: '수집 설정',
          desc: ['로그 수집 설정이 가능합니다.'],
          data: null,
          orderbyIndex: 1,
        },
        {
          id: 'alarmSettings',
          name: '알람 설정',
          desc: ['로그 알람을 설정할 수 있습니다.'],
          data: null,
          orderbyIndex: 2,
        },
        {
          id: 'patternSettings',
          name: '패턴 설정',
          desc: ['로그의 머신러닝 패턴을 설정할 수 있습니다.'],
          data: null,
          orderbyIndex: 3,
        },
      ],
    };
  },
  methods: {
    clearActiveView() {
      this.$refs.settingsSummary.clearActiveView();
    },
    onChangeMenu(activeView, activeMenu) {
      this.activeView = activeView;
      this.activeMenu = activeMenu;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/index.vue